module.exports = __webpack_public_path__ + "img/yourcall.85a74f23.png";